import { render, staticRenderFns } from "./WhatsappCostCard.vue?vue&type=template&id=10a6f392&scoped=true&"
import script from "./WhatsappCostCard.vue?vue&type=script&lang=js&"
export * from "./WhatsappCostCard.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappCostCard.vue?vue&type=style&index=0&id=10a6f392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a6f392",
  null
  
)

export default component.exports